import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "mt-20" }
const _hoisted_3 = { class: "van-cell" }
const _hoisted_4 = { style: {"padding-bottom":"1.5rem"} }
const _hoisted_5 = {
  class: "flex-n fac w-full",
  style: {"padding":"0 1rem"}
}
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["id"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { style: {"padding-bottom":"1.5rem"} }
const _hoisted_11 = { class: "submitcontent" }

import {onBeforeUnmount, onMounted, ref, watch, shallowRef,nextTick} from "vue";
import ZCell from "@/components/ZCell/ZCell.vue";
import ZCard from "@/components/ZCard/ZCard.vue";
import TimePicker from "@/components/TimePicker/TimePicker.vue";
import UploadImage from "@/components/UploadImage/UploadImage.vue";
import {solarToLunar} from '@/assets/ts/getLunarBySolar'
import '@wangeditor/editor/dist/css/style.css';
import {Editor} from '@wangeditor/editor-for-vue';
import obituaryApi from "@/utils/Api/Obituary";
import {showToast} from 'vant'
import {useRoute} from "vue-router";
import weChatObituaryApi from "@/utils/Api/WeChatObituary";
import router from "@/router";
import personobituaryApi from "@/utils/Api/PersonObituary";


export default /*@__PURE__*/_defineComponent({
  __name: 'memorialedit',
  setup(__props) {

const route=useRoute();
onMounted(() => {
  document.title = '编辑纪念堂';
  getMusicList();
  if(route.query.id){
    getDetail();
  }

})

const form = ref({
  //逝者信息
  deceasedname: '', //逝者姓名
  sex: 0, //性别
  birthdate: '', //出生日期
  deathtime: (new Date().getFullYear())+'-'+((new Date().getMonth()+1>9?'':'0')+(new Date().getMonth()+1))+'-'+((new Date().getDate()>9?'':'0')+new Date().getDate()), //逝世日期
  deathage: '', //逝者年龄
  deathimg: [], //遗像上传

  //家属信息
  username: '', //家属姓名
  telphone: '', //家属电话
  callrelation: '', //逝者称呼关系

  //讣告信息
  backgroupmusicid: '', //讣告音乐
  music: '', //音乐名称
  obituarytemplateid: 1, //模版
  obituarytemplate: 0,//模版目前定死
  obituarytemplateName: '默认模板',
  obituarycontent: '', //讣告正文
  obituaryTitle: '',//讣告标题
  obituarySignature: '',//讣告落款

  //生前照片
  deathInfoImgList: [],
  //讣告服务
  serviceprice: '', //服务价格
  remark: '', //信息备注
})

//获取详情
const getDetail=()=>{
  personobituaryApi.detail(route.query.id).then(res=>{

     form.value={
      ...res.data.obituaryBaseInfo,
      obituaryBaseInfoId:res.data.obituaryBaseInfo?.id,
      ...res.data.deathinfo,
      deathinfoId:res.data.deathinfo.id,
      ...res.data.obituaryfamilymember,
      obituaryfamilymemberId:res.data.obituaryfamilymember?.id,
      ...res.data.deathPhoto,
      ...res.data.obituarServiceModel,
      obituarServiceModelId:res.data.obituarServiceModel?.id,
      deathimg:res.data.deathinfo.deathimg?[res.data.deathinfo.deathimg]:[]
    }
    console.log('form',form.value)
    for(let i in musicList){
      if(musicList[i].id==form.value.backgroupmusicid){
        form.value.music=musicList[i].musicname
        break;
      }
    }
    form.value.obituarytemplateName='默认模板'
    form.value.obituarytemplate=0
    form.value.birthdate=form.value.birthdate.replace(' 00:00:00','');
    form.value.deathtime=form.value.deathtime.replace(' 00:00:00','');

    //自定义
    if(form.value.obituarytemplateid==1){
//使用模板
      writeModelContent()
    }

    console.log(form.value,'213123')
  })
}

watch(() => [form.value.birthdate, form.value.deathtime], (newval) => {
  console.log(23123,form.value.birthdate,form.value.deathtime)
  if (form.value.birthdate.length > 0 && form.value.deathtime.length > 0) {
    const birthdate=form.value.birthdate;

    const date1 = new Date(birthdate), date2 = new Date(form.value.deathtime);
    console.log('kk',date1, date2)
    let y1 = date1.getFullYear(), m1 = date1.getMonth() + 1, d1 = date1.getDate(),
        y2 = date2.getFullYear(), m2 = date2.getMonth() + 1, d2 = date2.getDate();
    if (y1 > y2) {
      //输入有误
      form.value.deathage = '';
    } else {
      if (m2 > m1 || m2 == m1 && d2 >= d1) {
        form.value.deathage = y2 - y1;
      } else {
        form.value.deathage = y2 - y1 - 1;
      }
    }
  } else {
    form.value.deathage = '';
  }
})


//模版
const show = ref(false);


const columns = [
  {text: '默认模版', value: '0'},
];
const isFocus=ref(true);
watch(()=>[form.value.deathtime,form.value.callrelation,form.value.deceasedname,form.value.deathage,form.value.username],()=>{
  isFocus.value=false;
  // writeModelContent();
})



//写模版内容
const writeModelContent = () => {

  let d = form.value;
  console.log('deathtime',d.deathtime)
  let deathtime = d.deathtime.split('-');

  let newday = d.deathtime ? new Date(new Date(deathtime).getTime() + 2 * 24 * 60 * 60 * 1000) : '';
  let date1 = d.deathtime ? (solarToLunar(Number(deathtime[0]), Number(deathtime[1]), Number(deathtime[2])).monthStr + solarToLunar(Number(deathtime[0]), Number(deathtime[1]), Number(deathtime[2])).dayStr ): '';
  let date4 = d.deathtime ? deathtime[0] + '年' + deathtime[1] + '月' + deathtime[2] + '日' : ''
  let date2 = newday ? (newday.getFullYear() + '年' + (newday.getMonth() + 1) + '月' + newday.getDate() + '日') : '';

  let date3 = newday ? solarToLunar(newday.getFullYear(), newday.getMonth() + 1, newday.getDate()).monthStr + solarToLunar(newday.getFullYear(), newday.getMonth() + 1, newday.getDate()).dayStr : '';

  form.value.obituarycontent2 = `<div>${d.callrelation || '[称呼关系]'}${d.deceasedname || '[逝者姓名]'}</div><div>      于${(date4) || '[逝世时间]'}农历${date1 || '[逝世时间计算农历]'}去世，享年${d.deathage >= 0 ? d.deathage : '[逝者年龄]'}岁。</div><div>      兹定于${date2 || '[公历(去世第3天出殡，去世当天算1天)]'} ${date3 || '[对应农历]'},举行遗体告别仪式。
      <br/>
      <div>特发此告！</div><div>${d.username || '[家属姓名]'}泣告</div>

      </div>`

}
watch(()=>isFocus.value,(newval)=>{
  if(newval){
    form.value.obituarycontent=form.value.obituarycontent2
  }
})
const onConfirmModule = ({selectedOptions}) => {
  show.value = false;
  form.value.obituarytemplate = selectedOptions[0].text;
}

//音乐选择
const showMusic = ref(false);

let musicList =[
//     {
//   id: 1,
//   musicname: '音乐1',
//   url: 'http://music.163.com/song/media/outer/url?id=1497588709.mp3'
// }, {
//   id: 2,
//   musicname: '音乐2',
//   url: 'http://music.163.com/song/media/outer/url?id=1497588709.mp3'
// }
];
const customFieldName = {
  text: 'musicname',
  value: 'id',
};

//获取音乐
const getMusicList=()=>{
  personobituaryApi.getBackGroundMusicList().then(res=>{
    console.log('音乐列表',res.data)
    musicList=res.data||[]
  })
}
const onConfirmMusic = ({selectedOptions}) => {
  console.log(selectedOptions)
  showMusic.value = false;
  form.value.music = selectedOptions[0].musicname;
  form.value.backgroupmusicid= selectedOptions[0].id;
}
let tempId = ref('');
const playAudio = (id: string) => {
  if (tempId.value != id) {
    if (tempId.value) {
      document.getElementById(tempId.value).pause();
      document.getElementById(tempId.value).currentTime = 0;
    }
    tempId.value = id;
    document.getElementById(id).play();

  } else {
    document.getElementById(id).pause();
    tempId.value = '';
  }

}


const editorRef = shallowRef();

onBeforeUnmount(() => {
  const editor = editorRef.value;
  if (editor == null) return
  editor.destroy()
})
// let toolbar: any;
const createdEditor = (editor: any) => {
  editorRef.value = editor;
  console.log('zz')
  writeModelContent();


}


const tabWay = ref(0);
const addLabel = (val: string) => {
  console.log(val)
}
const editorConfig = {
  placeholder: '写下讣文，深痛缅怀 …',
  MENU_CONF: {},
  autoFocus: false,
  readOnly: true,

}
const defaultContent = ref([
  {
    type: 'paragraph',
    children: [
      {text: '', fontFamily: '微软雅黑', fontSize: '16px'}
    ],
    lineHeight: 1.5
  }
])
const changeValue = (num: number) => {
  tabWay.value = num;
  console.log(editorRef.value.isDisabled())
  if (!tabWay.value) {
    editorRef.value.disable()
  } else {
    editorRef.value.enable()
  }
  console.log( editorRef.value.getHtml())

}
const getImgList=(formName:any,data:any)=>{
  console.log(formName,data)
  form.value[formName]=data;
}
//提交
const onSubmit = (values: any) => {
  console.log('submit1', values);
  let _form=form.value;
  personobituaryApi.updateOrAdd(route.query.id?1:0, {
    //讣告服务
    obituaryBaseInfo: {
      id:_form.obituaryBaseInfoId,
      // customerId:_form.customerId,
      // merchantMemberId:_form.merchantMemberId,
      // employeeId: _form.employeeId,
      // obituarytemplateid:_form.obituarytemplateid,
      backgroupmusicid:_form.backgroupmusicid,
      // obituarycontent: _form.obituarycontent,
      // remark: _form.remark,
      obituaryTitle:_form.obituaryTitle,//讣告标题
      // obituarySignature:_form.obituarySignature,//讣告落款
    },
    //逝者信息
    deathinfo: {
      id:_form.deathinfoId,
      deceasedname: _form.deceasedname, //逝者姓名
      // sex: _form.sex, //性别
      birthdate: _form.birthdate, //出生日期
      deathtime: _form.deathtime, //逝世日期
      deathage: _form.deathage, //逝者年龄
      deathimg: _form.deathimg?.[0], //遗像上传
    },
    //家属信息
    obituaryfamilymember: {
      id:_form.obituaryfamilymemberId,
      // username: _form.username, //家属姓名
      // telphone: _form.telphone, //家属电话
      // callrelation: _form.callrelation, //逝者称呼关系
    },
    deathPhoto: {
      //生前照片
      deathInfoImgList: _form.deathInfoImgList,
    },
    //讣告服务
    obituarServiceModel: {
      id:_form.obituarServiceModelId,
      // serviceprice: _form.serviceprice, //服务价格
      // remark: _form.remark, //信息备注
    }
  }).then(()=>{
    showToast({
      message:'编辑成功',
      onOpened(){
        router.push('/memoriallist')
      }
    });
  })
}


return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createBlock(_component_van_form, {
    onSubmit: onSubmit,
    "show-error": "",
    "show-error-message": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(ZCard, null, {
            default: _withCtx(() => [
              _createVNode(ZCell, {
                label: "逝者姓名",
                hiddenArrow: "",
                require: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: form.value.deceasedname,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.deceasedname) = $event)),
                    placeholder: "请输入",
                    rules: [{ required: true, message: '请填写逝者姓名' }]
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(ZCell, {
                label: "出生日期",
                require: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(TimePicker, {
                    modelValue: form.value.birthdate,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.birthdate) = $event)),
                    rules: [{ required: true, message: '请填写' }]
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(ZCell, {
                label: "逝世日期",
                require: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(TimePicker, {
                    modelValue: form.value.deathtime,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.deathtime) = $event)),
                    rules: [{ required: true, message: '请填写' }]
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(ZCell, {
                label: "逝者年龄",
                class: _normalizeClass(['cell-input', form.value.deathage!==''?'':'empty']),
                hiddenArrow: "",
                require: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(form.value.deathage !== '' ? form.value.deathage : '自动计算'), 1)
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(ZCell, {
                label: "遗像上传",
                hiddenArrow: "",
                wrap: "",
                require: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(UploadImage, {
                      count: 1,
                      list: form.value.deathimg,
                      "aspect-ratio": 4/5,
                      onGetImgList: _cache[3] || (_cache[3] = e=>getImgList('deathimg',e))
                    }, null, 8, ["list"])
                  ])
                ]),
                _: 1
              }),
              _createVNode(ZCell, {
                label: "模板选择",
                require: "",
                class: _normalizeClass(['cell-input',form.value.obituarytemplate!==''?'':'empty'])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: form.value.obituarytemplateName,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.obituarytemplateName) = $event)),
                    readonly: "",
                    placeholder: "请选择",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (show.value = true))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_popup, {
                    show: show.value,
                    "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((show).value = $event)),
                    round: "",
                    position: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_picker, {
                        columns: columns,
                        onCancel: _cache[6] || (_cache[6] = ($event: any) => (show.value = false)),
                        onConfirm: onConfirmModule
                      })
                    ]),
                    _: 1
                  }, 8, ["show"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(ZCell, {
                label: "音乐选择",
                require: "",
                class: _normalizeClass(['cell-input',form.value.backgroupmusicid!==''?'':'empty'])
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: form.value.music,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.music) = $event)),
                    readonly: "",
                    placeholder: "请选择",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (showMusic.value = true))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_van_popup, {
                    show: showMusic.value,
                    "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((showMusic).value = $event)),
                    round: "",
                    position: "bottom"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_picker, {
                        columns: _unref(musicList),
                        onCancel: _cache[10] || (_cache[10] = ($event: any) => (showMusic.value = false)),
                        "columns-field-names": customFieldName,
                        onConfirm: onConfirmMusic
                      }, {
                        option: _withCtx((data) => [
                          _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, _toDisplayString(data.musicname), 1),
                            _createElementVNode("div", {
                              onClick: ($event: any) => (playAudio('audio'+data.id))
                            }, [
                              _createVNode(_component_van_icon, {
                                size: "2rem",
                                color: _unref(tempId)!==('audio'+data.id)?'#0087ff':'#ff6666',
                                name: (_unref(tempId)!==('audio'+data.id)?'play':'pause')+'-circle-o'
                              }, null, 8, ["color", "name"])
                            ], 8, _hoisted_7),
                            _createElementVNode("audio", {
                              id: 'audio'+data.id
                            }, [
                              _createElementVNode("source", {
                                src: data.musicpath
                              }, null, 8, _hoisted_9)
                            ], 8, _hoisted_8)
                          ])
                        ]),
                        _: 1
                      }, 8, ["columns"])
                    ]),
                    _: 1
                  }, 8, ["show"])
                ]),
                _: 1
              }, 8, ["class"]),
              _createVNode(ZCell, {
                label: "纪念堂标题",
                hiddenArrow: "",
                require: "",
                "label-width": "7.5rem"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_field, {
                    modelValue: form.value.obituaryTitle,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.obituaryTitle) = $event)),
                    placeholder: "请输入",
                    rules: [{ required: true, message: '请填写纪念堂标题' }]
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(ZCell, {
                label: "生前照片",
                hiddenArrow: "",
                wrap: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(UploadImage, {
                      list: form.value.deathInfoImgList,
                      "is-crop": false,
                      onGetImgList: _cache[13] || (_cache[13] = e=>getImgList('deathInfoImgList',e))
                    }, null, 8, ["list"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _cache[15] || (_cache[15] = _createElementVNode("div", { style: {"height":"12.5rem"} }, null, -1)),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_van_button, {
            round: "",
            block: "",
            class: "primary-btn",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [
              _createTextVNode(" 提交 ")
            ])),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})